import {formatNumber} from "@angular/common";

export function raceLengthFormat(length: number | string | undefined, activeLang: string, unit?: "km" | "m" | undefined, withUnit: boolean = true): string | undefined {
    if (length !== undefined && length !== null && typeof Number(length) === "number") {
        return getRaceLength(Number(length), activeLang, unit, withUnit);
    }
    return "";
}

function getRaceLength(length: number | undefined, activeLang: string, unit: "km" | "m" = "km", withUnit: boolean = true): string {
    if (length == null || isNaN(length)) return "";

    let displayValue: number;
    let displayUnit: string;

    if (unit === "km") {
        displayValue = length;
        displayUnit = "km";
        if (length < 1) {
            displayValue = length * 1000;
            displayUnit = "m"
        }
    } else {
        if (length >= 1000) {
            displayValue = length / 1000;
            displayUnit = "km";
        } else {
            displayValue = length;
            displayUnit = "m";
        }
    }

    const formatted = formatNumber(displayValue, activeLang, '1.0-1');
    return formatted + (withUnit ? ` ${displayUnit}` : "");
}